import Vue from 'vue'
import moment from 'moment'
/* eslint-disable */
import TokenService from '../helpers/token';
import { userPositions } from '../helpers/constants';
import store from '@/store'
var loader = null
var loading = null
Vue.mixin({
  data() {
    return {
      currentPicker: null,
    };
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date)
          .format('DD/MM/YYYY');
      }
      return '';
    },
    customFormatDateTime(date) {
      if (date) {
        return moment(date)
            .format('YYYY-MM-DD HH:mm');
      }
      return '';
    },
    formatHour(date) {
      if (date) {
        return moment(date)
          .format('HH:mm:ss');
      }
      return '';
    },
    formatPrice(value, endFix = '') {
      const valueABS = Math.abs(value);
      if (isNaN(valueABS))
        return value;
      if (valueABS > -1000 && valueABS < 1000) {
        return value;
      }
      const valueNumber = Intl.NumberFormat('en-US').format(valueABS);
      if (Number(value) < 0) {
        return `-${valueNumber}`;
      }
      if (endFix) {
        return  valueNumber + endFix;
      }
      return valueNumber;
    },
    formatPriceNew(value, endFix = '') {
      const valueABS = Math.abs(value);
      if (isNaN(valueABS))
        return value;
      if (valueABS > -1000 && valueABS < 1000) {
        return value + endFix;
      }
      const valueNumber = Intl.NumberFormat('en-US').format(valueABS);
      if (Number(value) < 0) {
        return `-${valueNumber}`;
      }
      if (endFix) {
        return  valueNumber + endFix;
      }
      return valueNumber;
    },
    scrollToError(className = 'v-messages__message', container = 'body') {
      setTimeout(() => {
        const errorElement = document.getElementsByClassName(className);
        if (errorElement.length > 0) {
          // errorElement[0].scrollIntoView(false)
          this.$scrollTo(errorElement[0], {
            // container,
            duration: 500,
            easing: 'ease-in',
            offset: -150,
            force: true,
            cancelable: false,
            // x: true,
            y: true,
          });
        }
        if (container != 'body') {
          const errorElementContainer = document.getElementsByClassName(container);
          if (errorElementContainer.length > 0 && errorElement.length > 0) {
            let me = this
            this.$scrollTo(errorElement[0], {
              // container,
              duration: 500,
              easing: 'ease-in',
              offset: -150,
              force: true,
              cancelable: false,
              // x: true,
              y: true,
              onDone: function() {
                me.$scrollTo(errorElement[0], {
                  container: `.${container}`,
                  duration: 10,
                  easing: 'linear',
                  offset: 0,
                  force: true,
                  cancelable: false,
                  x: true,
                  y: false,
                })
              }
            });
          }
        }
      }, 100);
    },
    getTotalItem(totalItem, limit = 10) {
      return Math.floor((totalItem - 1) / limit) + 1
    },
    isStaff() {
      return TokenService.getPosition() === userPositions.TELESALES;
    },
    isAdmin() {
      return TokenService.getPosition() === userPositions.SALE_MANAGER;
    },
    isLeader() {
      return TokenService.getPosition() === userPositions.SALE_LEADER;
    },
    isManager() {
      return store.state.isManager
    },

    appLoadingData(isShow) {
      if (isShow && !loading && !loader) {
        loader = this.$loading.show()
        loading = true
      }
      if (!isShow) {
        loading = false
        setTimeout(() => {
          if(!loading && loader && typeof loader.hide == 'function'){
            loader.hide()
            if(loader && typeof loader.destroy == 'function'){
              loader.destroy()
            }
            loader = null
          }
        },  3000)
      }
    },
    formatPriceWithFractionDigits(value, numberOfFractionDigits) {
      const valueNumber = Intl.NumberFormat('en-US', {
        maximumFractionDigits: numberOfFractionDigits,
        minimumFractionDigits: numberOfFractionDigits
      }).format(value);
      if (Number(value) < 0) {
        return `-${valueNumber}`;
      }
      return valueNumber;
    },
    removeAccents(str) {
      let AccentsMap = [
        "aàảãáạăằẳẵắặâầẩẫấậ",
        "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
        "dđ", "DĐ",
        "eèẻẽéẹêềểễếệ",
        "EÈẺẼÉẸÊỀỂỄẾỆ",
        "iìỉĩíị",
        "IÌỈĨÍỊ",
        "oòỏõóọôồổỗốộơờởỡớợ",
        "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
        "uùủũúụưừửữứự",
        "UÙỦŨÚỤƯỪỬỮỨỰ",
        "yỳỷỹýỵ",
        "YỲỶỸÝỴ"
      ];
      for (let i=0; i<AccentsMap.length; i++) {
        let re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
        let char = AccentsMap[i][0];
        str = str.replace(re, char);
      }
      return str;
    },
    customFilterSearch(item, queryText, itemText) {
      if (!itemText) {
        return false;
      }
      return (
          itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
          ||
          this.removeAccents(itemText).toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
    },
    formatDateDot(date) {
      if (date) {
        return moment(date)
          .format('DD.MM.YYYY');
      }
      return '';
    },
    formatCurrency(val) {
      const cv = parseInt(val);
      const res = cv.toLocaleString('it-IT', {style : 'currency', currency : 'VND'}) || '';

      return res.slice(0, -3) + ' đ';
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    // formatDate (date) {
    //   if (!date) return null

    //   const [year, month, day] = date.split('-')
    //   return `${month}/${day}/${year}`
    // },
    dateTime(date) {
      if (date) {
        return moment(date)
            .format('HH:mm:ss DD/MM/YYYY');
      }
      return '';
    },
    showDate(index) {
      this.currentPicker = index;
    },
  },
});
